import { render, staticRenderFns } from "./MatchingSettings.vue?vue&type=template&id=3109b980"
import script from "./MatchingSettings.vue?vue&type=script&lang=js"
export * from "./MatchingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports